export default "__VITE_ASSET__Cywk0Jei__"